<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.priority')" filterable clearable
      :size="size" class="d-block">
      <el-option v-for="(priority,index) in priorities" :key="'priorities-' + index" :label="priority.name" :value="priority.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
       id:{
          default: null
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.priorities && this.priorities.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        priorities: 'priority/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'priority/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
